import { render, staticRenderFns } from "./EntitiesManager.vue?vue&type=template&id=48706b46&"
import script from "./EntitiesManager.vue?vue&type=script&lang=ts&"
export * from "./EntitiesManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports